import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Field, Formik, Form } from "formik";
import { utils } from "../../../utils"

export default class ModalDefault extends Component {

    submit = (ref) => {
        const formRef = ref
        if (formRef) {
            formRef.current.handleSubmit();
        }
    };

    render() {
        const { toggle, reference, is_open, extra_fields, button_success, on_submit } = this.props;
        return <Modal isOpen={is_open} toggle={toggle} style={{ width: "600px" }}>
            <ModalHeader toggle={toggle}>{this.props.header}</ModalHeader>
            <br />
            <ModalBody>
                <div className="container">
                    <Formik
                        onSubmit={(values, { resetForm }) => on_submit(values, resetForm)}
                        ref={reference}
                    >
                        {formik => {
                            return (
                                <Form>
                                    {extra_fields.map(
                                        (item, index) => {
                                            return (
                                                <div key={index} className="row">
                                                    <div className="form-group col">
                                                        <label>{item.label}</label>
                                                        <br></br>
                                                        <Field
                                                            validate={
                                                                item.validate_general ?
                                                                    (val) => utils.validateGeneral(val) : null
                                                            }
                                                            {...item.extra_props}
                                                        />
                                                        {<small className="text-danger form-text">{utils.renderError(formik, item.extra_props.name)}</small>}
                                                    </div>
                                                </div>
                                            )
                                        }
                                    )}
                                </Form>
                            )
                        }
                        }
                    </Formik>
                    {this.props.drop_component}
                </div>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-success" onClick={() => this.submit(reference)}>
                    {button_success}
                </button>
                <button className="btn btn-danger" onClick={toggle}>
                    Cancel
                </button>
            </ModalFooter>
        </Modal>
    }

}